import React from "react";
import "../../styles/LogoutCard.scss";
import { useKeycloak } from "@react-keycloak/web";
import logoutIcon from "../../images/LogoutIcon.png";
import { redirectUri } from "../../services/axiosConfigCS";

const LogoutDropdownCard = (props) => {
  const { getFirstLetters, getUserNameEmail } = props;
  const { keycloak } = useKeycloak();
  const userLogout = () => {
    keycloak.logout({ redirectUri: redirectUri });
    localStorage.removeItem("dontShowAgain");
  };
  const userName = getUserNameEmail?.userInfo?.name || "";
  const userEmail = getUserNameEmail?.userInfo?.email || "";

  return (
    <div className="logoutCard">
      <div className="logoutCardHeader">
        <div className="logoutAvatar">
          <span>{getFirstLetters()}</span>
        </div>

        <div className="logoutUserMeta">
          <div className="logoutCardName">{userName}</div>
          <div className="logoutCardEmail" title={userEmail}>
            {userEmail}
          </div>
        </div>
      </div>

      <hr className="logoutDivider" />
      <button className="logoutRow" type="button" onClick={userLogout}>
        <img src={logoutIcon} alt="" className="logoutRowIcon" />
        <span className="logoutRowText">Log Out</span>
      </button>
    </div>
  );
};

export default LogoutDropdownCard;
